import { DraftStage_ } from '../DraftStage_';
export class DraftComponents {
    DraftStage_ = DraftStage_;
}
